
<v-dialog persistent v-model="flag" max-width="600">
  <v-card @click:outside="closeDialog()" class="c-confirmation text-sm" style="">
    <div class="d-flex justify-content-start text-lg mb-2">
     <b>{{ title }}</b>
    </div>
    <div class="d-flex justify-content-start mb-4">
      {{ description }}
    </div>
    <div class="d-flex justify-content-end mb-2">
      <div role="button" @click="closeDialog()" class="btn btn-sm btn-outline-primary mr-2" :class="cancelClass">{{ cancelText }}</div>
      <div v-show="contradictText !== ''" role="button" @click="contradict()" class="btn btn-sm btn-danger mr-2">{{ contradictText }}</div>
      <div role="button" @click="confirmation()" class="btn btn-sm btn-primary" :class="confirmationClass">{{ confirmationText }}</div>
    </div>
  </v-card>
</v-dialog>
